/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminGetOrganizerInfoResponseDto { 
    /**
     * Organizer (user) id
     */
    id: string;
    /**
     * Display name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Avatar URL
     */
    avatarUrl: string | null;
    /**
     * Organizer account state
     */
    organizerState: AdminGetOrganizerInfoResponseDto.OrganizerStateEnum;
    /**
     * Stripe Connect status (DB-derived)
     */
    stripeConnectedStatus: AdminGetOrganizerInfoResponseDto.StripeConnectedStatusEnum;
    /**
     * Created at (ISO 8601)
     */
    createdAt: string;
    /**
     * Updated at (ISO 8601)
     */
    updatedAt: string;
}
export namespace AdminGetOrganizerInfoResponseDto {
    export type OrganizerStateEnum = 'active' | 'disabled';
    export const OrganizerStateEnum = {
        Active: 'active' as OrganizerStateEnum,
        Disabled: 'disabled' as OrganizerStateEnum
    };
    export type StripeConnectedStatusEnum = 'connected' | 'not-started' | 'access-revoked';
    export const StripeConnectedStatusEnum = {
        Connected: 'connected' as StripeConnectedStatusEnum,
        NotStarted: 'not-started' as StripeConnectedStatusEnum,
        AccessRevoked: 'access-revoked' as StripeConnectedStatusEnum
    };
}


